import React from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Input, PrimaryButton, Select, InformationAlert } from '../../Common';
import { Grey4 } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';
import { TranslateW } from '../../../Utils/Languages/Translate';

const RecordVitalStats = ({
    dropdownOptions,
    vitalStatData,
    setVitalStatState,
    closeDrawer,
    submitVitalStat,
}) => {

    const setNestedData = (key, value, index, lowest = null, highest = null) => {
        let newValue = value;
        if (lowest && value < lowest) {
            newValue = lowest;
        }
        if (highest && value > highest) {
            newValue = highest;
        }
        const valuesClone = [...vitalStatData.values];
        valuesClone[index][key] = newValue;
        return setVitalStatState({ values: valuesClone });
    };

    // set techId for each vitalStatValue as well as for top level UI
    const setTechnicianUserId = (technicianUserId) => {
        const valuesClone = [...vitalStatData.values].map(vs => ({ ...vs, technicianUserId }));
        return setVitalStatState({ values: valuesClone, technicianUserId  });
    };

    return (
        <Box
            sx={{ width: 600 }}
            role="presentation"
        >
            <Box p={3}>
                <Grid container spacing={4}>
                    <Grid container item justifyContent='flex-end'>
                        <IconButton
                            aria-label="close"
                            onClick={closeDrawer}
                            sx={{ backgroundColor: Grey4, borderRadius: '0px' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography sx={{ fontFamily: trakrefFontFamily, color: '#000', fontSize: '24px' }}>
                            Record Vital Stat
                        </Typography>
                    </Grid>
                    <Grid container item xs={6} justifyContent="flex-end">
                        <PrimaryButton
                            buttonText='Record Vital Stat'
                            size="small"
                            onClick={submitVitalStat}
                        />
                    </Grid>
                    {vitalStatData.warning && (
                        <Grid item xs={12} justifyContent="center">
                            <InformationAlert
                                message="Please enter a value for one or more vital stats."
                                onClose={() => setVitalStatState({ warning: false })}
                            />
                        </Grid>
                    )}
                </Grid>

                <Grid container mt={4} spacing={4}>
                    <Grid item xs={6} md={6} lg={6}>
                        <Select
                            required
                            variant='standard'
                            label={TranslateW("serviceEventView.primary-technician")}
                            value={vitalStatData.technicianUserId}
                            onChange={e => setTechnicianUserId(e.target.value)}
                            options={dropdownOptions.technicians}
                            error={vitalStatData.errors.technicianUserId}
                        />
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} />

                    {vitalStatData.inputFields.map((
                        {
                            numericOnly,
                            displayName,
                            onString,
                            offString,
                            lowest,
                            highest,
                        },
                        index
                    ) => (
                        <>
                            {!numericOnly ? (
                                <Grid item xs={6} md={6} lg={6} key={index}>
                                    <Select
                                        showNullOption
                                        variant='standard'
                                        label={displayName}
                                        value={vitalStatData.values[index]["value"]}
                                        onChange={e => setNestedData("value", e.target.value, index)}
                                        options={[onString, offString].map(option => ({ value: option, label: option }))}
                                    />
                                </Grid>
                            ) : (
                                <Grid item xs={6} md={6} lg={6} key={index}>
                                    <Input
                                        fullWidth
                                        label={displayName}
                                        variant='standard'
                                        type="number"
                                        minimumNumberValue={lowest}
                                        maximumNumberValue={highest}
                                        placeholder={(lowest && highest) ? `${lowest} to ${highest}` : ''}
                                        value={vitalStatData.values[index]["value"]}
                                        onChange={e => setNestedData("value", e.target.value, index, lowest, highest)}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6} md={6} lg={6}>
                                <Input
                                    fullWidth
                                    label='Notes'
                                    variant='standard'
                                    value={vitalStatData.values[index]["notes"]}
                                    onChange={e => setNestedData("notes", e.target.value, index)}
                                />
                            </Grid>
                        </>
                    ))}

                </Grid>
            </Box>
        </Box>
    );
};

export default RecordVitalStats;
